module.exports = __webpack_public_path__ + "static/media/146-gambia.4c44c9bf.svg";